import React, { FC } from 'react';
import classNames from 'classnames';

import './CircleLoader.scss';

interface IProps {
  value: number;
}

const CircleLoader: FC<IProps> = ({ value }) => (
  <div className={classNames('loader', `p${value}`)}>
    <div className="slice">
      <div className="bar" />
      <div className="fill" />
    </div>
  </div>
);

export default CircleLoader;
